<script setup lang="ts">
import type { Component } from 'vue'
import { computed } from 'vue'
import { useQuoteProductConfig } from '@/components/Quote/composables/useQuoteProductConfig'
const props = defineProps<{
  isMonthly?: boolean
  isYearly?: boolean
  interestAmount?: string | number
  paymentPlanApr?: string | number
  paymentPlanFee?: string | number
  totalPayable?: string | number
  productId?: string
}>()

defineOptions({ name: 'ConfirmationPleaseNote' })

// Per-tenant "please note" components keyed by `${tenantKey}-${productKey}`; empty until a tenant registers one.
const PLEASE_NOTE_COMPONENTS: Record<string, Component> = {}

const { config: productConfig } = useQuoteProductConfig(computed(() => props.productId))
const tenantKey = computed(() => productConfig.value?.tenantKey.toLowerCase() ?? '')

const productKey = computed(() => productConfig.value?.productKey.toLocaleLowerCase() ?? '')

const pleaseNoteComponent = computed<Component | null>(() => {
    const key = `${tenantKey.value}-${productKey.value}`

    return PLEASE_NOTE_COMPONENTS[key] ?? null
})
</script>

<template>
    <component 
        v-if="pleaseNoteComponent"
        :is="pleaseNoteComponent"
        :isMonthly="props.isMonthly"
        :interestAmount="props.interestAmount"
        :paymentPlanApr="props.paymentPlanApr"
        :paymentPlanFee="props.paymentPlanFee"
        :totalPayable="props.totalPayable"
        :productId="props.productId"
    />
</template>